import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import Moment from 'react-moment';
import DetalheBagagem from './DetalheBagagem'
import { alterarExibicaoBagagem, excluirBagagem, buscarBagagens, selecionaBagagem } from '../../actions/bagagem/bagagemActions';
import { Modal, Button } from 'react-bootstrap';

export class Bagagem extends React.Component {
  state = {
    showModal: false,
    bagagemSelecionada: null,
  };

  exibirIcone () {
    if (this.props.bagagem.exibirDetalhe) {
      return (
        <i className="material-icons" style={{ cursor: 'pointer' }}
          onClick={() => this.props.alterarExibicaoBagagem(this.props.bagagem)}>
          &#xE5C7;
        </i>
      )
    }
    return (
      <i className="material-icons" style={{ cursor: 'pointer' }}
        onClick={() => this.props.alterarExibicaoBagagem(this.props.bagagem)}>
        &#xE5C5;
      </i>
    )
  }

  abrirModal = (id) => {
    this.setState({ showModal: true, bagagemSelecionada: id });
  };


  fecharModal = () => {
    this.setState({ showModal: false, bagagemSelecionada: null });
  };

  selecionaBagagem = (bagagem) => {
    this.props.selecionaBagagem(bagagem);
    this.props.history.push('/recibo-bagagem');
  }


 confirmarRemocao = () => {
   if (this.state.bagagemSelecionada) {
     this.props.excluirBagagem(this.state.bagagemSelecionada);
   }
   this.props.buscarBagagens(this.props.empresaSelecionada.id);
   this.fecharModal();
 };


  render () {
    const b = this.props.bagagem

    return (
      <div className="geral">
        <div className="resumo">
          <div className="row align-items-center">
            <div className="col" style={{ cursor: 'pointer' }}>
              {this.exibirIcone()}
            </div>

            <div className="col">
              <span className="titulo-mobile">Nº Reserva:&nbsp;</span>{b.reservaId}
            </div>

            <div className="col">
              <span className="titulo-mobile">Identificador:&nbsp;</span>{b.codigoRastreio}
            </div>

            <div className="col">
              <span className="titulo-mobile">Passageiro:&nbsp;</span>{b.nomePassageiro}
            </div>

            <div className="col">
              <span className="titulo-mobile">Vendedor:&nbsp;</span>{b.nomeVendedor}
            </div>

            <div className="col">
              <span className="titulo-mobile">Situação:&nbsp;</span>
              {b.situacao}
            </div>

            <div className="col">
              <span className="titulo-mobile">Data:&nbsp;</span>
              <Moment format="DD/MM/YYYY">{b.dataHoraRegistro}</Moment>
            </div>

            <div className="col">
              <span className="titulo-mobile">Valor:&nbsp;</span>
              {b.valor?.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              }) || 'R$ 0,00'}
            </div>


            <div className="col">
              <span className="titulo-mobile">Peso:&nbsp;</span>
              {b.peso?.toLocaleString('pt-BR', {
                 minimumFractionDigits: 2,
                 maximumFractionDigits: 2
               }) + ' kg' || '0,00 kg'}
            </div>

            <div className="col">
              <div className="acoes-bagagem">
                {b.habilitadoCancelamento ? <button
                  type="button"
                  className="btn btn-sm btn-danger me-2 w-100"
                  disabled={!b.ativa}
                  onClick={() => this.abrirModal(b.id)}>
                  Cancelar
                </button>:''}
                <button
                  type="button"
                  className="btn btn-sm btn-laranja mt-1 w-100"
                  onClick={() => this.selecionaBagagem(b)}>
                  Cupom
                </button>

              </div>
            </div>
          </div>
        </div>

        <DetalheBagagem bagagem={b}/>

        {/* Modal de Confirmação */}
        <Modal show={this.state.showModal} onHide={this.fecharModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Confirmação</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Tem certeza que deseja cancelar esta bagagem?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.fecharModal}>
              Não
            </Button>
            <Button variant="danger" onClick={this.confirmarRemocao}>
              Sim
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

export const mapStateToProps = state => ({
  empresaSelecionada: state.empresaSelecionada,
})

export default connect(mapStateToProps, {
  alterarExibicaoBagagem,
  excluirBagagem,
  buscarBagagens,
  selecionaBagagem,
})(withRouter(Bagagem));
